var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { parseMonth } from "@ui/utils/month";
import { Box, Button, Grid, IconButton, useMediaQuery, Typography, Alert, MenuItem, Skeleton, CircularProgress, Tooltip, Dialog, DialogTitle, DialogContent, DialogActions, Menu, } from "@mui/material";
import { PageHeader } from "@ui/components/header/PageHeader";
import { NoModuleAccess } from "@ui/components/no-module-access/NoModuleAccess";
import FDrawer from "@ui/components/drawer/FDrawer";
import React, { useState, useEffect, useCallback, useRef } from "react";
import { useDispatch } from "react-redux";
import { Edit2, InfoCircle } from "iconsax-react";
import { FMenu } from "@ui/components/menu/FMenu";
import { ForcastAdjustDialog } from "./ForcastAdjustDialog";
import ConfirmDialog from "@ui/components/dialog/Confirmation";
import { ProjectTable } from "./ProjectTable";
import { ProjectTableDrawer } from "./ProjectTableDrawer";
import { TreeMenuNew } from "@ui/components/tree-menu/TreeMenuNew";
import { stack2 } from "@ui/components/style/style";
import { Icon } from "@iconify/react";
import { skipToken } from "@reduxjs/toolkit/query";
import { useGetProjectSnapshotsQuery, useGetProjectTreeQuery, useGetCombinedMetricsQuery, projectsApi, useSaveProjectMetricMutation, useCreateForecastAdjustmentMutation, useGetProjectValuationLevelQuery, useUpsertProjectValuationLevelMutation, useDeleteProjectMetricSavesMutation, useDeleteProjectCostValuesMutation, useDeleteForecastAdjustmentByProjectMutation, } from "../../../features/projects/projectsApi";
import { useDeleteCostComponentsByProjectMutation } from "../../../features/costComponents/costComponentsApi";
import { useRefreshProjectStatusesHierarchyMutation, useResetProjectStatusesMutation, } from "../../../features/projectStatuses/projectStatusesApi";
import { useParams, useSearchParams, useNavigate, Navigate, } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import { useSnackbar } from "notistack";
import { useGetCompanyMonthConfigsQuery } from "../../../features/companyMonthConfigs/companyMonthConfigsApi";
import { usePermissions } from "../../../context/PermissionContext";
import { CloseIcon } from "@ui/assets/custom-icons/close-icon";
import { getProjectNeighbours, rememberProjectNavList, toProjectNavEntry, } from "@ui/utils/projectNavigation";
// Utility function to transform flat ProjectTreeNodeDto array to hierarchical TreeNode structure
const transformProjectTreeData = (flatData) => {
    if (!flatData || flatData.length === 0)
        return [];
    const nodeMap = new Map();
    const rootNodes = [];
    // First pass: create all TreeNode entries
    flatData.forEach((item, index) => {
        var _a;
        const tooltipText = item.projectNumber && item.projectDescription
            ? `${item.projectNumber}: ${item.projectDescription}`
            : item.tooltipPath || "";
        const node = {
            id: item.projectNumber || `node-${index}`,
            // Number in front of the description: sibling subprojects often share the
            // same description and truncate to identical text in the tree, so the
            // number is the only thing that tells them apart.
            label: item.projectNumber && item.projectDescription
                ? `${item.projectNumber}: ${item.projectDescription}`
                : item.projectDescription || `Project ${item.projectNumber}`,
            percentage: item.afgerondPercentage,
            isExpandable: false,
            level: item.depth,
            tooltipPath: tooltipText,
            isSaved: (_a = item.isSaved) !== null && _a !== void 0 ? _a : false,
        };
        nodeMap.set(node.id, node);
    });
    // Second pass: wire up parent → child relationships using parentProjectNumber
    flatData.forEach((item) => {
        const node = nodeMap.get(item.projectNumber || "");
        if (!node)
            return;
        if (!item.parentProjectNumber) {
            rootNodes.push(node);
        }
        else {
            const parent = nodeMap.get(item.parentProjectNumber);
            if (parent) {
                if (!parent.children)
                    parent.children = [];
                parent.children.push(node);
                parent.isExpandable = true;
            }
            else {
                // Orphaned node (parent not in dataset) — treat as root
                rootNodes.push(node);
            }
        }
    });
    return rootNodes;
};
export const ProjectDetails = () => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("lg"));
    const isMobile = useMediaQuery((theme) => theme.breakpoints.down("md"));
    const [searchParams] = useSearchParams();
    const theme = useTheme();
    const { enqueueSnackbar } = useSnackbar();
    const { canRead, canUpdate, isLoading: isLoadingPermissions, isAuthError: isPermissionAuthError, } = usePermissions();
    const [openForecastDialog, setOpenForecastDialog] = useState(false);
    const navigate = useNavigate();
    const [treeDrawerOpen, setTreeDrawerOpen] = useState(false);
    const [expandedNodes, setExpandedNodes] = useState(new Set());
    const [activeNodeId, setActiveNodeId] = useState(searchParams.get("childProjectNumber") ||
        searchParams.get("topProjectNumber") ||
        undefined);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [selectedChildProject, setSelectedChildProject] = useState(searchParams.get("childProjectNumber") ||
        searchParams.get("topProjectNumber") ||
        undefined);
    const [showInfoAlert, setShowInfoAlert] = useState(true);
    const [unitType, setUnitType] = useState(() => { var _a; return (_a = localStorage.getItem("project-unitType")) !== null && _a !== void 0 ? _a : "full"; });
    const handleUnitTypeChange = useCallback((value) => {
        localStorage.setItem("project-unitType", value);
        setUnitType(value);
    }, []);
    const [menuAnchor, setMenuAnchor] = useState(null);
    const [valuationPromptOpen, setValuationPromptOpen] = useState(false);
    const [, setDialogValuationLevel] = useState(null);
    const [isChangingLevel, setIsChangingLevel] = useState(false);
    const [pendingLevel, setPendingLevel] = useState(null);
    const [unitMenuAnchor, setUnitMenuAnchor] = useState(null);
    const [valuationMenuAnchor, setValuationMenuAnchor] = useState(null);
    const handleMenuOpen = (event) => {
        setMenuAnchor(event.currentTarget);
    };
    const handleMenuClose = () => {
        setMenuAnchor(null);
    };
    const { projectId } = useParams();
    // Get parameters from URL query string
    const topProjectNumber = searchParams.get("topProjectNumber") || "";
    const entityName = searchParams.get("entityName") || "";
    const companyId = searchParams.get("companyId") || "";
    const isChildProjectParam = searchParams.get("isChildProject");
    const isChildProject = isChildProjectParam === "true";
    const childProjectNumberParam = searchParams.get("childProjectNumber");
    const hasUpdatePermission = canUpdate("Projects");
    // activeNodeId/selectedChildProject are seeded from the URL in their useState
    // initialisers, which run on mount only. Vorige/Volgend project changes the
    // query string on the same route, so the component is NOT remounted and both
    // would keep pointing at the previous project: the header falls back to the
    // bare project number and the metrics query still asks for the old project.
    // Re-seed with the same rule the initialisers use whenever the URL moves to a
    // different project. Tree clicks write childProjectNumber into the URL too, so
    // this re-seeds to the value they just set rather than fighting them.
    useEffect(() => {
        const seeded = childProjectNumberParam || topProjectNumber || undefined;
        setActiveNodeId(seeded);
        setSelectedChildProject(seeded);
    }, [childProjectNumberParam, topProjectNumber]);
    const { data: companyMonthConfigs, isLoading: isLoadingCompanyMonthConfigs, isFetching: isFetchingCompanyMonthConfigs, } = useGetCompanyMonthConfigsQuery(companyId, {
        skip: !companyId,
        refetchOnMountOrArgChange: true,
    });
    const { data: projectTreeData, 
    // isFetching, not isLoading: stepping to a neighbour project with a cached
    // tree keeps isLoading false, so the old tree stayed on screen with no
    // skeleton until the refetch landed.
    isFetching: isTreeLoading, error: treeError, refetch: refetchTree, } = useGetProjectTreeQuery({
        topProjectNumber,
        entityName,
        companyId,
        isChildProject,
    }, {
        skip: !topProjectNumber || !entityName, // Skip the query if parameters are missing
        refetchOnMountOrArgChange: true,
    });
    // Derive the depth of the currently selected node from the flat tree data
    const selectedNodeDepth = (_a = projectTreeData === null || projectTreeData === void 0 ? void 0 : projectTreeData.find((n) => n.projectNumber === selectedChildProject)) === null || _a === void 0 ? void 0 : _a.depth;
    // Fetch combined metrics for the selected project
    const { data: combinedMetrics, refetch: refetchMetrics, isLoading: isLoadingCombinedMetrics, isFetching: isFetchingCombinedMetrics, } = useGetCombinedMetricsQuery({
        parentProjectNumber: topProjectNumber,
        childProjectNumber: selectedChildProject || topProjectNumber,
        companyId: companyId,
        isChildProject: isChildProject,
        nodeDepth: selectedNodeDepth,
    }, {
        skip: !topProjectNumber ||
            !selectedChildProject ||
            !companyId ||
            selectedNodeDepth === undefined,
        refetchOnMountOrArgChange: true,
    });
    const [isProcessing, setIsProcessing] = useState(false);
    const [saveProjectMetric] = useSaveProjectMetricMutation();
    const dispatch = useDispatch();
    const [createForecastAdjustment] = useCreateForecastAdjustmentMutation();
    const [refreshProjectStatusesHierarchy] = useRefreshProjectStatusesHierarchyMutation();
    const [resetProjectStatuses] = useResetProjectStatusesMutation();
    const activeConfigMonth = Array.isArray(companyMonthConfigs) && companyMonthConfigs.length > 0
        ? companyMonthConfigs[0].configMonth
        : "";
    const { data: valuationLevelData, isSuccess: isValuationLevelLoaded, refetch: refetchValuationLevel, } = useGetProjectValuationLevelQuery({
        projectNumber: topProjectNumber,
        companyId,
        configMonth: activeConfigMonth,
    }, { skip: !topProjectNumber || !companyId || !activeConfigMonth });
    const [upsertValuationLevel] = useUpsertProjectValuationLevelMutation();
    const [deleteProjectMetricSaves] = useDeleteProjectMetricSavesMutation();
    const [deleteProjectCostValues] = useDeleteProjectCostValuesMutation();
    const [deleteCostComponentsByProject] = useDeleteCostComponentsByProjectMutation();
    const [deleteForecastAdjustmentByProject] = useDeleteForecastAdjustmentByProjectMutation();
    const isValuationLevelExplicitlySet = isValuationLevelLoaded &&
        valuationLevelData !== null &&
        !valuationLevelData.isCarryForwarded;
    const maxTreeLevel = projectTreeData
        ? Math.max(...projectTreeData.map((n) => { var _a; return ((_a = n.depth) !== null && _a !== void 0 ? _a : 0) + 1; }), 1)
        : 5;
    // For display purposes fall back to maxTreeLevel so all nodes stay visible
    // until the user explicitly selects a valuation level.
    const valuationLevel = (_b = valuationLevelData === null || valuationLevelData === void 0 ? void 0 : valuationLevelData.valuationLevel) !== null && _b !== void 0 ? _b : maxTreeLevel;
    const currentNodeLevel = (selectedNodeDepth !== null && selectedNodeDepth !== void 0 ? selectedNodeDepth : 0) + 1;
    const isBelowValuationLevel = currentNodeLevel > valuationLevel;
    const isNotAtValuationLevel = currentNodeLevel !== valuationLevel;
    const hasCompanyConfigMonth = Array.isArray(companyMonthConfigs) && companyMonthConfigs.length > 0;
    // POC button: disabled when pocReadOnly is false, enabled when true
    const isPocDisabled = isLoadingCompanyMonthConfigs ||
        isFetchingCompanyMonthConfigs ||
        !hasCompanyConfigMonth ||
        !((_c = companyMonthConfigs[0]) === null || _c === void 0 ? void 0 : _c.pocReadOnly);
    // Forecast/Margin buttons: disabled when no config month
    const isSaveDisabled = isLoadingCompanyMonthConfigs ||
        isFetchingCompanyMonthConfigs ||
        !hasCompanyConfigMonth;
    // Format GUID to proper format (xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx)
    const formatGuid = (guid) => {
        const cleaned = guid.replace(/[-\s]/g, "");
        if (!/^[0-9a-f]{32}$/i.test(cleaned)) {
            return guid;
        }
        return `${cleaned.slice(0, 8)}-${cleaned.slice(8, 12)}-${cleaned.slice(12, 16)}-${cleaned.slice(16, 20)}-${cleaned.slice(20, 32)}`;
    };
    const noAccess = !isLoadingPermissions && !isPermissionAuthError && !canRead("Projects");
    // Handle saving metrics
    // Only call refreshProjectStatuses on 'Cijfers opslaan', not on forecast aanpassen or dialog open
    const handleSaveMetrics = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c;
        setIsProcessing(true);
        if (isSaveDisabled) {
            enqueueSnackbar("Opslaan is uitgeschakeld: geen configuratiemaand voor dit bedrijf", { variant: "warning" });
            setIsProcessing(false);
            return;
        }
        if (!combinedMetrics || !topProjectNumber) {
            enqueueSnackbar("Geen metriekgegevens beschikbaar om op te slaan", {
                variant: "warning",
            });
            setIsProcessing(false);
            return;
        }
        if (!companyId) {
            enqueueSnackbar("CompanyId ontbreekt: projectstatus refresh is overgeslagen", {
                variant: "warning",
            });
        }
        try {
            // Store what the numbers are now: the on-screen figures already include
            // this month's earlier save, so ask the backend to recalculate without it.
            const freshMetrics = yield dispatch(projectsApi.endpoints.getCombinedMetrics.initiate({
                parentProjectNumber: topProjectNumber,
                childProjectNumber: selectedChildProject || topProjectNumber,
                companyId: companyId,
                isChildProject: isChildProject,
                nodeDepth: selectedNodeDepth,
                fresh: true,
            }, 
            // One-off read: no cache subscription, so the save's invalidation does not refetch it.
            { subscribe: false, forceRefetch: true })).unwrap();
            // Get PTD Margin value from additionalMetrics
            const marginMetric = (_a = freshMetrics.additionalMetrics) === null || _a === void 0 ? void 0 : _a.find((m) => m.metric.toLowerCase().includes("marg") &&
                !m.metric.toLowerCase().includes("%"));
            if (!marginMetric) {
                enqueueSnackbar("Margin metriek niet gevonden", {
                    variant: "warning",
                });
                setIsProcessing(false);
                return;
            }
            // Get PTD POC value from additionalMetrics
            const pocMetric = (_b = freshMetrics.additionalMetrics) === null || _b === void 0 ? void 0 : _b.find((m) => m.metric.toLowerCase().includes("poc"));
            if (!pocMetric) {
                enqueueSnackbar("POC metriek niet gevonden", {
                    variant: "warning",
                });
                setIsProcessing(false);
                return;
            }
            // Get PTD Kosten value from additionalMetrics
            const kostenMetric = (_c = freshMetrics.additionalMetrics) === null || _c === void 0 ? void 0 : _c.find((m) => m.metric.toLowerCase().includes("kosten"));
            // Save Margin, POC and Kosten PTD
            const savePromises = [
                saveProjectMetric({
                    parentProjectNumber: topProjectNumber,
                    childProjectNumber: selectedChildProject || topProjectNumber,
                    metricName: "Marg",
                    ptdValue: marginMetric.ptd,
                    companyId: companyId,
                }).unwrap(),
                createForecastAdjustment({
                    projectNumber: topProjectNumber,
                    projectId: projectId ? formatGuid(projectId.trim()) : null,
                    childProjectNumber: selectedChildProject || null,
                    pocOverrule: pocMetric.ptd,
                    adjustmentCategory: "AutoSave",
                    comment: null,
                    companyId: companyId,
                }).unwrap(),
            ];
            if (kostenMetric) {
                savePromises.push(saveProjectMetric({
                    parentProjectNumber: topProjectNumber,
                    childProjectNumber: selectedChildProject || topProjectNumber,
                    metricName: "Kosten",
                    ptdValue: kostenMetric.ptd,
                    companyId: companyId,
                }).unwrap());
            }
            yield Promise.all(savePromises);
            // Only call refreshProjectStatuses as part of 'Cijfers opslaan', not on forecast aanpassen
            if (companyId) {
                try {
                    yield refreshProjectStatusesHierarchy({
                        companyId,
                        parentProjectNumber: topProjectNumber,
                        childProjectNumber: selectedChildProject || topProjectNumber,
                        isChildProject,
                    }).unwrap();
                }
                catch (_d) {
                    enqueueSnackbar("Projectstatus refresh mislukt", {
                        variant: "warning",
                    });
                }
            }
            enqueueSnackbar("Cijfers succesvol opgeslagen", {
                variant: "success",
            });
            refetchTree();
        }
        catch (_e) {
            enqueueSnackbar("Fout bij het opslaan van cijfers", {
                variant: "error",
            });
        }
        finally {
            setIsProcessing(false);
        }
    });
    // Buttons are always disabled until the user has explicitly selected a valuation level.
    // Once a level IS selected, disable the buttons only when the current node
    // is at the wrong level.
    const pocButtonDisabled = !isValuationLevelExplicitlySet ||
        isPocDisabled ||
        !hasUpdatePermission ||
        isLoadingCombinedMetrics ||
        isFetchingCombinedMetrics ||
        isChangingLevel ||
        isProcessing ||
        isNotAtValuationLevel;
    const saveButtonsDisabled = !isValuationLevelExplicitlySet ||
        isSaveDisabled ||
        !hasUpdatePermission ||
        isChangingLevel ||
        isProcessing ||
        isNotAtValuationLevel;
    // Menu items for mobile
    const menuItems = [
        {
            label: "POC aanpassen",
            disabled: pocButtonDisabled,
            onClick: () => {
                handleMenuClose();
                setOpenForecastDialog(true);
            },
        },
        {
            label: "Forecast aanpassen",
            disabled: saveButtonsDisabled,
            onClick: () => {
                handleMenuClose();
                const params = new URLSearchParams(searchParams);
                params.set("childProjectNumber", selectedChildProject || topProjectNumber);
                params.set("isChildProject", String(isChildProject));
                navigate(`/project/${projectId}/details/forecast?${params.toString()}`, {
                    state: {
                        projectName: selectedTooltipPath || `${topProjectNumber}: ${entityName}`,
                    },
                });
            },
        },
        {
            label: "Cijfers opslaan",
            disabled: saveButtonsDisabled,
            onClick: () => {
                handleMenuClose();
                handleSaveMetrics();
            },
        },
    ];
    // Handle expand/collapse toggle
    const handleToggle = (nodeId) => {
        const newExpanded = new Set(expandedNodes);
        if (newExpanded.has(nodeId)) {
            newExpanded.delete(nodeId);
        }
        else {
            newExpanded.add(nodeId);
        }
        setExpandedNodes(newExpanded);
    };
    // Handle node selection
    const handleNodeClick = (nodeId) => {
        setActiveNodeId(nodeId);
        setSelectedChildProject(nodeId);
        // Persist the selected child in the URL so refresh/back navigation restores it
        const params = new URLSearchParams(searchParams);
        params.set("childProjectNumber", nodeId);
        navigate(`?${params.toString()}`, { replace: true });
        // Open drawer on mobile when a node is selected
        if (isSmallScreen && nodeId) {
            setDrawerOpen(true);
        }
    };
    // Handle drawer close
    const handleDrawerClose = () => {
        setDrawerOpen(false);
    };
    // Close drawer when screen size changes from mobile to desktop
    useEffect(() => {
        if (!isSmallScreen && drawerOpen) {
            setDrawerOpen(false);
        }
    }, [isSmallScreen, drawerOpen]);
    // Helper function to find a node by ID in the tree
    const findNodeById = (nodes, nodeId) => {
        for (const node of nodes) {
            if (node.id === nodeId) {
                return node;
            }
            if (node.children) {
                const found = findNodeById(node.children, nodeId);
                if (found)
                    return found;
            }
        }
        return null;
    };
    // Mark nodes below the valuation level as greyed out
    const applyGreyOut = (nodes, vLevel) => nodes.map((n) => {
        var _a, _b;
        return (Object.assign(Object.assign({}, n), { isGreyedOut: ((_a = n.level) !== null && _a !== void 0 ? _a : 0) + 1 > vLevel, isSaved: isValuationLevelExplicitlySet && ((_b = n.level) !== null && _b !== void 0 ? _b : 0) + 1 === vLevel
                ? n.isSaved
                : undefined, children: n.children ? applyGreyOut(n.children, vLevel) : undefined }));
    });
    // Get the selected node's tooltipPath
    const transformedTreeData = projectTreeData
        ? applyGreyOut(transformProjectTreeData(projectTreeData), valuationLevel)
        : [];
    const selectedNode = activeNodeId
        ? findNodeById(transformedTreeData, activeNodeId)
        : null;
    const selectedTooltipPath = (selectedNode === null || selectedNode === void 0 ? void 0 : selectedNode.tooltipPath) || "";
    // Vorige/Volgend project, based on the list the user clicked through from.
    const storedNeighbours = getProjectNeighbours(projectId, topProjectNumber);
    // Only one page of rows is remembered. When the open project is on the first
    // or last row of it, fetch the neighbouring page so Vorige/Volgend crosses the
    // page boundary instead of going dead.
    const { data: adjacentPageResult } = useGetProjectSnapshotsQuery((_d = storedNeighbours.adjacentRequest) !== null && _d !== void 0 ? _d : skipToken);
    const projectNeighbours = React.useMemo(() => {
        var _a;
        const rows = (_a = adjacentPageResult === null || adjacentPageResult === void 0 ? void 0 : adjacentPageResult.data) !== null && _a !== void 0 ? _a : [];
        if (!storedNeighbours.adjacentSide || rows.length === 0) {
            return storedNeighbours;
        }
        // "next" is supplied by the first row of the following page, "previous" by
        // the last row of the preceding one.
        const row = storedNeighbours.adjacentSide === "next"
            ? rows[0]
            : rows[rows.length - 1];
        const entry = toProjectNavEntry(row, storedNeighbours.companyId, storedNeighbours.aanneemsom);
        return storedNeighbours.adjacentSide === "next"
            ? Object.assign(Object.assign({}, storedNeighbours), { next: entry }) : Object.assign(Object.assign({}, storedNeighbours), { previous: entry });
    }, [storedNeighbours, adjacentPageResult]);
    // Walk to a neighbouring project. When that neighbour lives on the adjacent
    // page, that page has to become the remembered list first — otherwise the
    // project we land on is not in the stored page, the position reads 0 and the
    // buttons die after a single crossing.
    const goToNeighbour = useCallback((entry, side) => {
        var _a, _b, _c;
        if (!entry)
            return;
        const rows = (_a = adjacentPageResult === null || adjacentPageResult === void 0 ? void 0 : adjacentPageResult.data) !== null && _a !== void 0 ? _a : [];
        if (side === storedNeighbours.adjacentSide &&
            storedNeighbours.adjacentPage !== null &&
            rows.length > 0) {
            const request = storedNeighbours.adjacentRequest;
            rememberProjectNavList({
                entries: rows
                    .filter((r) => !(r === null || r === void 0 ? void 0 : r.isTotals))
                    .map((r) => toProjectNavEntry(r, storedNeighbours.companyId, storedNeighbours.aanneemsom)),
                page: storedNeighbours.adjacentPage,
                pageSize: (_c = (_b = request === null || request === void 0 ? void 0 : request.pagination) === null || _b === void 0 ? void 0 : _b.pageSize) !== null && _c !== void 0 ? _c : rows.length,
                totalCount: storedNeighbours.total,
                request,
                companyId: storedNeighbours.companyId,
                aanneemsom: storedNeighbours.aanneemsom,
            });
        }
        navigate(entry.url);
    }, [storedNeighbours, adjacentPageResult, navigate]);
    // Projectnaam for the details card. Read from the flat tree rather than the
    // node label, which is prefixed with the project number. While the tree for a
    // newly opened project is still loading, fall back to the description the
    // overview already recorded so the field isn't briefly empty.
    const selectedNodeDescription = ((_e = projectTreeData === null || projectTreeData === void 0 ? void 0 : projectTreeData.find((n) => n.projectNumber === (selectedChildProject || topProjectNumber))) === null || _e === void 0 ? void 0 : _e.projectDescription) ||
        ((_f = projectNeighbours.current) === null || _f === void 0 ? void 0 : _f.label) ||
        "";
    // Projectleider for the selected node, so it follows the tree selection the way
    // Projectnaam does. Empty when the data lake has no lead for that project.
    const selectedNodeProjectLead = ((_g = projectTreeData === null || projectTreeData === void 0 ? void 0 : projectTreeData.find((n) => n.projectNumber === (selectedChildProject || topProjectNumber))) === null || _g === void 0 ? void 0 : _g.projectLeadName) || "";
    // Auto-open valuation prompt when page loads and no level exists at all for
    // this month. A carry-forwarded level is handled silently below instead of
    // prompting the user to re-confirm it.
    useEffect(() => {
        if (isValuationLevelLoaded && valuationLevelData === null) {
            setValuationPromptOpen(true);
        }
    }, [isValuationLevelLoaded, valuationLevelData]);
    // Silently confirm a carry-forwarded level so it persists as this month's
    // explicit value and the user is never asked to re-select the same level.
    const confirmedCarryForwardKeyRef = useRef(null);
    useEffect(() => {
        if (!isValuationLevelLoaded ||
            !valuationLevelData ||
            !valuationLevelData.isCarryForwarded ||
            !topProjectNumber ||
            !companyId ||
            !activeConfigMonth) {
            return;
        }
        const key = `${topProjectNumber}|${companyId}|${activeConfigMonth}`;
        if (confirmedCarryForwardKeyRef.current === key)
            return;
        confirmedCarryForwardKeyRef.current = key;
        upsertValuationLevel({
            projectNumber: topProjectNumber,
            companyId,
            configMonth: activeConfigMonth,
            valuationLevel: valuationLevelData.valuationLevel,
        })
            .unwrap()
            .then(() => refetchValuationLevel())
            .catch(() => {
            confirmedCarryForwardKeyRef.current = null;
        });
    }, [
        isValuationLevelLoaded,
        valuationLevelData,
        topProjectNumber,
        companyId,
        activeConfigMonth,
        upsertValuationLevel,
        refetchValuationLevel,
    ]);
    // Auto-expand all nodes and select first node when tree data loads
    useEffect(() => {
        if (projectTreeData && projectTreeData.length > 0) {
            const transformedData = transformProjectTreeData(projectTreeData);
            // Auto-expand all expandable nodes
            const allExpandableNodes = new Set();
            const collectExpandableNodes = (nodes) => {
                nodes.forEach((node) => {
                    if (node.isExpandable) {
                        allExpandableNodes.add(node.id);
                        if (node.children) {
                            collectExpandableNodes(node.children);
                        }
                    }
                });
            };
            collectExpandableNodes(transformedData);
            setExpandedNodes(allExpandableNodes);
            // Auto-select the first node (root node) if no node is currently selected
            if (!activeNodeId && transformedData.length > 0) {
                const firstNode = transformedData[0];
                setActiveNodeId(firstNode.id);
                setSelectedChildProject(firstNode.id);
                const params = new URLSearchParams(searchParams);
                params.set("childProjectNumber", firstNode.id);
                navigate(`?${params.toString()}`, { replace: true });
            }
        }
    }, [projectTreeData, activeNodeId]);
    // Project navigation lives in the page header, next to "Projectgegevens".
    // position 0 means this project is not in the remembered list (opened by
    // link, or the list is from another filter) — both chevrons would be dead, so
    // render nothing rather than a meaningless "0 / n".
    const projectNavControl = projectNeighbours.position > 0 ? (React.createElement(Box, { sx: {
            display: "flex",
            alignItems: "center",
            gap: 1,
            flexShrink: 0,
        } },
        React.createElement(Tooltip, { title: "Blader door dezelfde projectlijst waar u vandaan kwam, zonder terug te gaan naar het overzicht.", arrow: true },
            React.createElement(IconButton, { size: "small", "aria-label": "Uitleg projectnavigatie", sx: {
                    color: "text.secondary",
                    border: "1px solid",
                    borderColor: "divider",
                } },
                React.createElement(Icon, { icon: "material-symbols:info-outline", width: 18, height: 18 }))),
        React.createElement(Box, { sx: {
                display: "flex",
                alignItems: "center",
                gap: 0.5,
                border: "1px solid",
                borderColor: "divider",
                borderRadius: 999,
                px: 0.5,
            } },
            React.createElement(Tooltip, { title: projectNeighbours.previous
                    ? `Vorig project: ${projectNeighbours.previous.label}`
                    : "Eerste project in de lijst", arrow: true },
                React.createElement("span", null,
                    React.createElement(IconButton, { size: "small", "aria-label": "Vorig project", disabled: !projectNeighbours.previous, onClick: () => goToNeighbour(projectNeighbours.previous, "previous") },
                        React.createElement(Icon, { icon: "material-symbols:chevron-left", width: "20", height: "20" })))),
            React.createElement(Typography, { variant: "body2", sx: { color: "text.secondary", whiteSpace: "nowrap" } },
                projectNeighbours.position,
                " / ",
                projectNeighbours.total),
            React.createElement(Tooltip, { title: projectNeighbours.next
                    ? `Volgend project: ${projectNeighbours.next.label}`
                    : "Laatste project in de lijst", arrow: true },
                React.createElement("span", null,
                    React.createElement(IconButton, { size: "small", "aria-label": "Volgend project", disabled: !projectNeighbours.next, onClick: () => goToNeighbour(projectNeighbours.next, "next") },
                        React.createElement(Icon, { icon: "material-symbols:chevron-right", width: "20", height: "20" }))))))) : null;
    return (React.createElement(Box, null,
        isLoadingPermissions ? (React.createElement(Box, { sx: { p: 4, textAlign: "center" } },
            React.createElement(CircularProgress, null))) : isPermissionAuthError ? (React.createElement(Navigate, { to: "/login", replace: true })) : noAccess ? (React.createElement(NoModuleAccess, { message: "U heeft geen toegang tot de projecten module" })) : (React.createElement(React.Fragment, null,
            React.createElement(PageHeader, { title: "Projectgegevens", breadcrumbs: selectedTooltipPath
                    ? [
                        { label: "Projecten", path: "/project" },
                        { label: `(${selectedTooltipPath})` },
                    ]
                    : undefined, onBack: () => navigate("/project"), actions: React.createElement(React.Fragment, null,
                    projectNavControl,
                    isSmallScreen ? (React.createElement(Box, { sx: {
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                        } },
                        React.createElement(IconButton, { color: "primary", sx: {
                                backgroundColor: theme.palette.tertiary[40],
                                color: "white",
                                "&:hover": {
                                    backgroundColor: "primary.dark",
                                },
                            }, onClick: handleMenuOpen },
                            React.createElement(Edit2, { variant: "Bulk" })))) : null,
                    React.createElement(FMenu, { anchorEl: menuAnchor, open: Boolean(menuAnchor), handleClose: handleMenuClose, menuItems: menuItems })) }),
            React.createElement(Grid, { container: true, spacing: { xs: 1, sm: 2, md: 2, lg: 4 } },
                React.createElement(Grid, { size: { xs: 12, sm: 12, md: 12, lg: 3 } },
                    React.createElement(Box, { sx: {
                            maxHeight: {
                                xs: "calc(100vh - 300px)",
                                sm: "calc(100vh - 250px)",
                            },
                            background: theme.palette.background.neutral,
                            borderRadius: "24px",
                            backdropFilter: "blur(40px)",
                            overflow: "auto",
                        } }, !topProjectNumber || !entityName ? (React.createElement(Box, { sx: { p: 2, textAlign: "center", color: "text.secondary" } }, "Ontbrekende projectparameters. Navigeer vanaf de projectlijst.")) : isTreeLoading ? (React.createElement(Box, { sx: { p: 2 } },
                        React.createElement(Box, { sx: { px: 2, pt: 2, mb: 2 } },
                            React.createElement(Skeleton, { variant: "text", width: 140, height: 32 })),
                        [...Array(isSmallScreen ? 1 : 8)].map((_, index) => (React.createElement(Box, { key: index, sx: {
                                pl: index % 3 === 0 ? 2 : index % 3 === 1 ? 4 : 6,
                                pr: 2,
                                mb: 1,
                            } },
                            React.createElement(Skeleton, { variant: "rectangular", height: 40, sx: { borderRadius: 1 } })))))) : treeError ? (React.createElement(Box, { sx: { p: 2, textAlign: "center", color: "error.main" } }, "Fout bij het laden van projectboom")) : transformedTreeData.length === 0 ? (React.createElement(Box, { sx: { p: 2, textAlign: "center", color: "text.secondary" } }, "Geen gegevens beschikbaar.")) : (React.createElement(React.Fragment, null,
                        React.createElement(Box, { sx: {
                                px: 2,
                                pt: 2,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                            } },
                            React.createElement(Typography, { variant: "h6", sx: {
                                    fontWeight: 500,
                                    color: theme.palette.tertiary[30],
                                } }, "Projectboom"),
                            React.createElement(Tooltip, { title: "Door op een subproject in deze sectie te klikken, opent u de details in Projectgegevens.", arrow: true },
                                React.createElement(Box, { sx: { display: "flex", alignItems: "center" } },
                                    React.createElement(Icon, { icon: "hugeicons:information-circle", width: "18", height: "18", color: theme.palette.info.main })))),
                        React.createElement(TreeMenuNew, { data: transformedTreeData, expandedNodes: expandedNodes, activeNodeId: activeNodeId, onToggle: handleToggle, onNodeClick: handleNodeClick, isMobile: isSmallScreen ? true : false, showOnlyFirst: isSmallScreen ? true : false, hideChildren: isSmallScreen ? true : false, onMaximizeClick: () => setTreeDrawerOpen(true) }))))),
                isSmallScreen && (React.createElement(React.Fragment, null,
                    React.createElement(FDrawer, { open: treeDrawerOpen, onClose: () => setTreeDrawerOpen(false), header: React.createElement(Box, { sx: {
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                            } },
                            React.createElement(Typography, { variant: "h6" }, "Projectboom"),
                            React.createElement(Tooltip, { title: "Door op een subproject in deze sectie te klikken, opent u de details in Projectgegevens.", arrow: true },
                                React.createElement(Box, { sx: { display: "flex", alignItems: "center" } },
                                    React.createElement(Icon, { icon: "hugeicons:information-circle", width: "18", height: "18", color: theme.palette.info.main })))) },
                        React.createElement(Box, { sx: {
                                background: theme.palette.background.neutral,
                                borderRadius: "24px",
                                p: 2,
                            } }, !topProjectNumber || !entityName ? (React.createElement(Box, { sx: {
                                p: 2,
                                textAlign: "center",
                                color: "text.secondary",
                            } }, "Ontbrekende projectparameters. Navigeer vanaf de projectlijst.")) : isTreeLoading ? (React.createElement(Box, { sx: { p: 2 } },
                            React.createElement(Box, { sx: { mb: 2 } },
                                React.createElement(Skeleton, { variant: "text", width: 140, height: 32 })),
                            [...Array(isSmallScreen ? 1 : 8)].map((_, index) => (React.createElement(Box, { key: index, sx: {
                                    pl: index % 3 === 0 ? 0 : index % 3 === 1 ? 2 : 4,
                                    mb: 1,
                                } },
                                React.createElement(Skeleton, { variant: "rectangular", height: 40, sx: { borderRadius: 1 } })))))) : treeError ? (React.createElement(Box, { sx: { p: 2, textAlign: "center", color: "error.main" } }, "Error loading project tree")) : (React.createElement(TreeMenuNew, { data: transformedTreeData, expandedNodes: expandedNodes, activeNodeId: activeNodeId, onToggle: handleToggle, onNodeClick: (nodeId) => {
                                handleNodeClick(nodeId);
                                setTreeDrawerOpen(false);
                            } })))))),
                React.createElement(Grid, { size: { xs: 12, sm: 12, md: 12, lg: 9 }, sx: {
                        height: isSmallScreen ? "auto" : "calc(100dvh - 260px)",
                        overflow: "auto",
                        pb: 1,
                        pr: 1,
                    } }, isTreeLoading || isChangingLevel ? (React.createElement(Box, { sx: { p: 2 } },
                    React.createElement(Box, { sx: {
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            flexWrap: "wrap",
                            gap: 3,
                            mb: 3,
                        } },
                        React.createElement(Skeleton, { variant: "text", width: 250, height: 40 }),
                        React.createElement(Skeleton, { variant: "rectangular", width: 140, height: 40, sx: { borderRadius: 1 } })),
                    React.createElement(Box, { sx: Object.assign({}, stack2) }, [...Array(1)].map((_, index) => (React.createElement(Skeleton, { key: index, variant: "rectangular", height: 32, sx: { borderRadius: 2 } })))),
                    React.createElement(Box, { sx: Object.assign({}, stack2) },
                        React.createElement(Skeleton, { variant: "text", width: 220, height: 32, sx: { mb: 2 } }),
                        React.createElement(Skeleton, { variant: "rectangular", height: 400, sx: { borderRadius: 2, mb: 3 } }),
                        React.createElement(Skeleton, { variant: "text", width: 240, height: 32, sx: { mb: 2 } }),
                        React.createElement(Skeleton, { variant: "rectangular", height: 400, sx: { borderRadius: 2 } })))) : (React.createElement(React.Fragment, null,
                    React.createElement(Box, { sx: {
                            display: "flex",
                            flexDirection: "column",
                            gap: 1.5,
                            pt: 2,
                        } },
                        React.createElement(Box, { sx: {
                                display: "flex",
                                justifyContent: isMobile
                                    ? "flex-start"
                                    : "space-between",
                                alignItems: "center",
                                flexWrap: isSmallScreen ? "wrap" : "nowrap",
                                gap: isSmallScreen ? 1.5 : 1,
                            } },
                            React.createElement(Typography, { variant: "h5", noWrap: true, sx: {
                                    fontWeight: 500,
                                    flex: isMobile ? "0 0 100%" : 1,
                                    minWidth: 0,
                                } }, "Project details"),
                            React.createElement(React.Fragment, null,
                                React.createElement(Tooltip, { title: React.createElement(Box, { sx: { maxWidth: 320, p: 0.5 } },
                                        React.createElement(Typography, { variant: "body2", gutterBottom: true, sx: {
                                                fontWeight: 600,
                                            } }, "Waarderingsniveau"),
                                        React.createElement(Typography, { variant: "body2", gutterBottom: true }, "Bepaalt op welk projectniveau de financi\u00EBle cijfers worden weergegeven en ingevoerd. Alleen projectknooppunten op het geselecteerde niveau kunnen worden bewerkt en opgeslagen."),
                                        React.createElement(Typography, { variant: "body2", gutterBottom: true, sx: {
                                                fontWeight: 600,
                                                mt: 1,
                                            } }, "NB (Niet Beschikbaar)-weergave"),
                                        React.createElement(Typography, { variant: "body2" },
                                            "Forecast Kosten, Projectmarge en POC% worden als",
                                            " ",
                                            React.createElement("strong", null, "NB"),
                                            " weergegeven voor projectentiteiten die zich lager dan het waarderingsniveau bevinden.")), arrow: true, placement: "bottom-start" },
                                    React.createElement(IconButton, { size: "small", sx: { color: "text.secondary" } },
                                        React.createElement(Icon, { icon: "material-symbols:info-outline", width: 18, height: 18 }))),
                                React.createElement(Button, { variant: "soft", color: "primary", size: "medium", endIcon: React.createElement(Icon, { icon: "material-symbols:keyboard-arrow-down", width: 20, height: 20 }), onClick: (e) => setUnitMenuAnchor(e.currentTarget), sx: {
                                        marginLeft: isMobile ? 0 : "auto",
                                        textTransform: "none",
                                        color: "#2476A9",
                                        background: "#3192D00D",
                                    } }, unitType === "K" ? "K (Duizend)" : "Volledig"),
                                React.createElement(Menu, { anchorEl: unitMenuAnchor, open: Boolean(unitMenuAnchor), onClose: () => setUnitMenuAnchor(null) },
                                    React.createElement(MenuItem, { selected: unitType === "K", onClick: () => {
                                            handleUnitTypeChange("K");
                                            setUnitMenuAnchor(null);
                                        }, sx: { fontSize: "0.875rem" } }, "K (Duizend)"),
                                    React.createElement(MenuItem, { selected: unitType === "full", onClick: () => {
                                            handleUnitTypeChange("full");
                                            setUnitMenuAnchor(null);
                                        }, sx: { fontSize: "0.875rem" } }, "Volledig"))),
                            React.createElement(React.Fragment, null,
                                React.createElement(Button, { variant: "soft", color: "primary", size: "medium", disabled: !hasUpdatePermission || isChangingLevel, endIcon: isChangingLevel ? (React.createElement(CircularProgress, { size: 14, color: "inherit" })) : (React.createElement(Icon, { icon: "material-symbols:keyboard-arrow-down", width: 20, height: 20 })), onClick: (e) => setValuationMenuAnchor(e.currentTarget), sx: {
                                        textTransform: "none",
                                        color: "#2476A9",
                                        background: "#3192D00D",
                                    } },
                                    React.createElement(Box, { sx: {
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 1,
                                        } },
                                        React.createElement(Box, { component: "span", sx: !isValuationLevelExplicitlySet &&
                                                isValuationLevelLoaded
                                                ? { color: "text.disabled" }
                                                : undefined },
                                            "Niveau ",
                                            valuationLevel),
                                        !isValuationLevelExplicitlySet &&
                                            isValuationLevelLoaded && (React.createElement(Box, { component: "span", sx: {
                                                fontSize: "0.65rem",
                                                fontWeight: 600,
                                                px: 0.75,
                                                py: 0.25,
                                                borderRadius: 1,
                                                backgroundColor: "warning.light",
                                                color: "warning.dark",
                                                lineHeight: 1.4,
                                            } }, "Standaard")))),
                                React.createElement(Menu, { anchorEl: valuationMenuAnchor, open: Boolean(valuationMenuAnchor), onClose: () => setValuationMenuAnchor(null) }, Array.from({ length: maxTreeLevel }, (_, i) => {
                                    const lvl = i + 1;
                                    const isDefault = !isValuationLevelExplicitlySet &&
                                        lvl === valuationLevel;
                                    return (React.createElement(MenuItem, { key: lvl, selected: isValuationLevelExplicitlySet &&
                                            lvl === valuationLevel, onClick: () => {
                                            setPendingLevel(lvl);
                                            setValuationMenuAnchor(null);
                                        }, sx: Object.assign({ fontSize: "0.875rem" }, (isDefault && {
                                            color: "text.disabled",
                                        })) },
                                        "Niveau ",
                                        lvl,
                                        isDefault && (React.createElement(Box, { component: "span", sx: {
                                                ml: 1,
                                                fontSize: "0.65rem",
                                                fontWeight: 600,
                                                px: 0.75,
                                                py: 0.25,
                                                borderRadius: 1,
                                                backgroundColor: "warning.light",
                                                color: "warning.dark",
                                            } }, "Standaard"))));
                                }))),
                            !isSmallScreen && (React.createElement(React.Fragment, null,
                                menuItems
                                    .filter((item) => item.label !== "Cijfers opslaan")
                                    .map((item) => (React.createElement(Button, { key: item.label, variant: "outlined", color: "tertiary", size: "medium", disabled: item.disabled, onClick: item.onClick, sx: { textTransform: "none" } }, item.label))),
                                React.createElement(Button, { variant: "contained", color: "tertiary", size: "medium", disableElevation: true, disabled: saveButtonsDisabled, onClick: handleSaveMetrics, startIcon: isProcessing ? (React.createElement(CircularProgress, { size: 16, color: "inherit" })) : null, sx: { textTransform: "none" } }, isProcessing ? "Opslaan..." : "Cijfers opslaan")))),
                        React.createElement(Box, { sx: {
                                display: "flex",
                                flexWrap: "wrap",
                                gap: { xs: 2, md: 6 },
                                px: 3,
                                py: 2,
                                borderRadius: 3,
                                border: `1px solid ${theme.palette.divider}`,
                                backgroundColor: theme.palette.background.paper,
                            } }, [
                            {
                                label: "Projectleider",
                                // Explicit "N/A" rather than the em dash the other
                                // fields fall back to: no lead is a real state here.
                                value: selectedNodeProjectLead || "N/A",
                                grow: false,
                            },
                            {
                                label: "Projectnummer",
                                value: selectedChildProject || topProjectNumber,
                                grow: false,
                            },
                            {
                                label: "Projectnaam",
                                value: selectedNodeDescription,
                                // Takes the rest of the row: names are long and were
                                // being cut off at a fixed 420px with the card still
                                // half empty to the right.
                                grow: true,
                            },
                        ].map((field) => (React.createElement(Box, { key: field.label, sx: {
                                minWidth: 0,
                                flex: field.grow ? 1 : "0 0 auto",
                            } },
                            React.createElement(Typography, { variant: "caption", sx: { color: theme.palette.tertiary[30] } }, field.label),
                            React.createElement(Tooltip, { title: field.value || "", arrow: true },
                                React.createElement(Typography, { variant: "body1", noWrap: true, sx: { fontWeight: 500 } }, field.value || "—")))))),
                        showInfoAlert && (React.createElement(Alert, { variant: "standard", sx: {
                                borderRadius: 3,
                                display: "flex",
                                alignItems: "center",
                                "& .MuiAlert-icon": {
                                    display: "flex",
                                    alignItems: "center",
                                },
                                "& .MuiAlert-message": {
                                    display: "flex",
                                    alignItems: "center",
                                    flex: 1,
                                },
                                "& .MuiAlert-action": {
                                    display: "flex",
                                    alignItems: "center",
                                    paddingTop: 0,
                                    paddingRight: 0,
                                },
                            }, severity: "info", icon: React.createElement(InfoCircle, { variant: "Bulk", color: theme.palette.info.main, size: 24 }), 
                            // icon={<Icon icon="hugeicons:fill-information-circle" width="18" height="18" color={theme.palette.info.main} />}
                            action: React.createElement(IconButton, { size: "small", onClick: () => setShowInfoAlert(false), sx: {
                                    color: theme.palette.info.darker,
                                    border: "none",
                                    "&:hover": {
                                        backgroundColor: "transparent",
                                    },
                                } },
                                React.createElement(Icon, { icon: "mingcute:close-line", width: "18", height: "18" })) }, "Deze inzichten omvatten gegevens van alle subprojecten die aan dit project zijn gerelateerd.")),
                        React.createElement(Box, { sx: {
                                display: "grid",
                                gridTemplateColumns: {
                                    xs: "1fr",
                                    lg: "repeat(3, 1fr)",
                                },
                                gap: 1.5,
                            } }),
                        React.createElement(ProjectTable, { parentProjectNumber: topProjectNumber, childProjectNumber: selectedChildProject || topProjectNumber, projectName: selectedTooltipPath || undefined, unitType: unitType, isChildProject: isChildProject, isBelowValuationLevel: isBelowValuationLevel, isOutsideValuationLevel: isNotAtValuationLevel, projectId: projectId, nodeDepth: selectedNodeDepth })))))),
            React.createElement(ConfirmDialog, { isOpen: pendingLevel !== null, onClose: () => setPendingLevel(null), variant: "delete", actionText: "Waarderingsniveau wijzigen", customMessage: `Weet je zeker dat je het waarderingsniveau wilt wijzigen naar niveau ${pendingLevel}? Alle ingevoerde waarden van gebruikers (Forecast Kosten, Forecast Kosten-componenten en POC%) voor ${(_j = (_h = parseMonth(activeConfigMonth)) === null || _h === void 0 ? void 0 : _h.toLocaleDateString("nl-NL", { month: "long", year: "numeric" })) !== null && _j !== void 0 ? _j : "de huidige maand"} worden verwijderd met deze wijziging.`, loading: isChangingLevel, onConfirm: () => __awaiter(void 0, void 0, void 0, function* () {
                    if (pendingLevel === null)
                        return;
                    const newLevel = pendingLevel;
                    setIsChangingLevel(true);
                    setPendingLevel(null);
                    try {
                        if (activeConfigMonth) {
                            yield Promise.all([
                                deleteProjectMetricSaves({
                                    companyId,
                                    parentProjectNumber: topProjectNumber,
                                    configMonth: activeConfigMonth,
                                }).unwrap(),
                                deleteProjectCostValues({
                                    companyId,
                                    projectNumber: topProjectNumber,
                                    configMonth: activeConfigMonth,
                                }).unwrap(),
                                deleteCostComponentsByProject({
                                    companyId,
                                    projectNumber: topProjectNumber,
                                    configMonth: activeConfigMonth,
                                }).unwrap(),
                                deleteForecastAdjustmentByProject({
                                    projectNumber: topProjectNumber,
                                    companyId,
                                    configMonth: activeConfigMonth,
                                }).unwrap(),
                            ]);
                        }
                        yield upsertValuationLevel({
                            projectNumber: topProjectNumber,
                            companyId,
                            configMonth: activeConfigMonth,
                            valuationLevel: newLevel,
                        }).unwrap();
                        // All saves were just deleted — reset every status under this parent to
                        // "Nog te doen" so stale "Afgerond" rows don't corrupt future hierarchy checks.
                        if (activeConfigMonth) {
                            try {
                                yield resetProjectStatuses({
                                    companyId,
                                    parentProjectNumber: topProjectNumber,
                                    configMonth: activeConfigMonth,
                                }).unwrap();
                            }
                            catch (_a) {
                                // Non-fatal: statuses will self-correct on the next save
                            }
                        }
                        yield Promise.all([
                            refetchMetrics ? refetchMetrics() : Promise.resolve(),
                            refetchTree(),
                        ]);
                    }
                    catch (_b) {
                        enqueueSnackbar("Wijzigen van waarderingsniveau mislukt", {
                            variant: "warning",
                        });
                    }
                    finally {
                        setIsChangingLevel(false);
                    }
                }) }),
            React.createElement(ForcastAdjustDialog, { open: openForecastDialog, onClose: () => {
                    setOpenForecastDialog(false);
                    // Refetch tree and metrics when dialog closes
                    if (refetchTree) {
                        refetchTree();
                    }
                    if (refetchMetrics) {
                        refetchMetrics();
                    }
                }, parentProjectNumber: topProjectNumber, childProjectNumber: selectedChildProject || topProjectNumber, projectId: projectId, companyId: companyId, isSaveDisabled: pocButtonDisabled, pocPtdValue: (_l = (_k = combinedMetrics === null || combinedMetrics === void 0 ? void 0 : combinedMetrics.additionalMetrics) === null || _k === void 0 ? void 0 : _k.find((m) => m.metric === "POC%")) === null || _l === void 0 ? void 0 : _l.ptd }),
            React.createElement(ProjectTableDrawer, { open: drawerOpen, onClose: handleDrawerClose, activeNodeId: activeNodeId, isMobile: isSmallScreen, parentProjectNumber: topProjectNumber, childProjectNumber: selectedChildProject || topProjectNumber, projectName: selectedTooltipPath || undefined, unitType: unitType, projectId: projectId, nodeDepth: selectedNodeDepth }))),
        (() => {
            const handleClose = () => {
                setValuationPromptOpen(false);
                setDialogValuationLevel(null);
            };
            return (React.createElement(Dialog, { open: valuationPromptOpen, onClose: handleClose, maxWidth: "xs", fullWidth: true, slotProps: {
                    paper: { sx: { borderRadius: "24px" } },
                } },
                React.createElement(DialogTitle, { sx: {
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: 2,
                        pt: 3,
                        pb: 1.5,
                        pl: 3,
                        pr: 1.5,
                    } },
                    React.createElement(Typography, { sx: {
                            fontSize: 18,
                            fontWeight: 500,
                            lineHeight: "28px",
                            color: "#161c24",
                        } }, "Waarderingsniveau vereist"),
                    React.createElement(IconButton, { onClick: handleClose, size: "small", sx: {
                            borderRadius: "500px",
                            width: 28,
                            height: 28,
                            flexShrink: 0,
                        } },
                        React.createElement(CloseIcon, null))),
                React.createElement(DialogContent, { sx: {
                        display: "flex",
                        flexDirection: "column",
                        gap: 1.5,
                        px: 3,
                        pt: 1,
                    } },
                    React.createElement(Typography, { sx: {
                            fontSize: 15,
                            fontWeight: 400,
                            lineHeight: "24px",
                            color: "#161c24",
                        } }, "Er is nog geen waarderingsniveau ingesteld voor deze maand. Selecteer een niveau om door te gaan. Het huidig geselecteerde niveau is een standaardwaarde en vereist bevestiging."),
                    React.createElement(Typography, { sx: {
                            fontSize: 15,
                            fontWeight: 400,
                            lineHeight: "24px",
                            color: "#161c24",
                        } },
                        "Gebruik de ",
                        React.createElement("strong", null, "Waarderingsniveau"),
                        " keuzelijst op de pagina om een niveau te bevestigen voordat u wijzigingen kunt aanbrengen.")),
                React.createElement(DialogActions, { sx: { px: 3, py: 3 } },
                    React.createElement(Button, { variant: "contained", color: "tertiary", onClick: handleClose, sx: {
                            borderRadius: "40px",
                            height: 36,
                            px: 2.5,
                            textTransform: "none",
                            fontSize: 14,
                            fontWeight: 500,
                        } }, "Begrepen"))));
        })()));
};
